import styled from "styled-components";

export const RightStyle = styled.div`
  background-color:  #DABAAD;
    border-radius: 20px;
  .tvc{
    float: right;
  }
`;
export const ContentStyle = styled.div`
    border-radius: 10px;
    border: none;
    .right{
      background-color: #DABAAD;
      border-radius: 20px;
    }
`;  
export const LeftStyle = styled.div`
  border: 1px solid rgb(192, 187, 187);
    border-radius: 20px;
    .quanty{
      padding:0 5px;
    }
    /* .checkcart{
      float: left;
    } */
`;
export const SelectStyle = styled.select`
    width:50%;
`;
